<!-- <a href="{{file}}" *ngIf="file"> -->
<span *ngIf="file">
  <img src="assets/img/contract-doc.png" *ngIf="isDoc()">
  <img src="assets/img/contract-pdf.png" *ngIf="isPdf()">
  <!-- assets/img/doc-icon2.jpg -->
  <!-- assets/img/doc-icon3.jpg -->
  <img src="assets/img/doc-icon4.jpg" *ngIf="isPpt()">
</span>